export default "__VITE_ASSET__52c98a39__"